module.exports = __webpack_public_path__ + "img/dz.c81d52f9.svg";